import React, { Component } from "react";
import { LoaderPage } from "../component/Loader";
import ListingLoader from "../component/LoaderTemplate";
import { Modal } from "react-bootstrap";
import {
  STATUS,
  PATHS,
  PARIVESH_MAPPING_FC,
  PARIVESH_MAPPING_WLC,
  PARIVESH_MAPPING_EC_CRZ
} from "../constant";
import { get } from "lodash";
import { getPariveshDetails } from "./../actions/common.action";
import LoaderTemplate from "../component/LoaderTemplate";
import PariveshListTemplate from "../component/LoadersTemplate/PariveshListTemplate";
const NoDataFoundIcon =
  "https://pmiic-local-files.s3.ap-south-1.amazonaws.com/no_data_found.png";
class PariveshData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pariveshData: null
    };
  }
  componentDidMount = async () => {
    const { issueSubCategoryId, proposalNoParivesh } = this.props;
    const data = {
      subCategoryId: issueSubCategoryId,
      proposalId: proposalNoParivesh
    };
    this.setState(
      {
        isPariveshLoading: STATUS.LOADING
      },
      async () => {
        const resp = await getPariveshDetails(undefined, data);
        console.log("response parivesh", resp);
        if (resp && resp.status) {
          this.setState({
            isPariveshLoading: STATUS.SUCCESS,
            pariveshData: resp.data
          });
        } else {
          this.setState({
            //issueData: resp,
            isPariveshLoading: STATUS.FAILURE
          });
        }
      }
    );
  };
  render() {
    const { show, closeModal, issueSubCategoryId } = this.props;
    const { isPariveshLoading, pariveshData } = this.state;
    console.log("pariveshData", pariveshData);
    return (
      <React.Fragment>
        <LoaderPage
          className="parivesh_loading"
          loading={isPariveshLoading === STATUS.LOADING}
        />
        <Modal
          show={show}
          dialogClassName="modal-parivesh-details"
          onHide={closeModal}
        >
          <Modal.Header closeButton>
            <Modal.Title>Proposal Details (PARIVESH)</Modal.Title>
          </Modal.Header>
          <Modal.Body className="scroll">
            {isPariveshLoading === STATUS.LOADING ? (
              <>
                <LoaderTemplate
                  height={80}
                  width={300}
                  times={1}
                  children={<PariveshListTemplate />}
                />
              </>
            ) : isPariveshLoading === STATUS.FAILURE ? (
              <div className="no-data-wrapper">
                <div className="img-container">
                  <img src={NoDataFoundIcon} alt="No Data" />
                  <h3 className={`no-data-found`}>
                    INVALID PROPOSAL NUMBER / NO DATA FOUND
                  </h3>
                </div>
              </div>
            ) : issueSubCategoryId === 1 || issueSubCategoryId === 71 ? (
              //For FC
              <div className="parivesh-detail-unit-wrapper">
                <div className="parivesh-proposal-no">
                  <span>Proposal Number:</span>
                  <div>{get(pariveshData, "proposalNo")}</div>
                </div>
                <hr />
                {PARIVESH_MAPPING_FC.map(({ key, label }) =>
                  key === "inPrincipalApprovalStatus" ? (
                    <div
                      className="parivesh-detail-unit parivesh-status"
                      key={key}
                    >
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, "approvalDate") ? (
                          <button className="parivesh-granted">Granted</button>
                        ) : (
                          <button className="parivesh-inprogress">
                            In-Progress
                          </button>
                        )}
                      </div>
                    </div>
                  ) : key === "dateOfSubmission" ||
                    key === "approvalDate" ||
                    key === "finalApprovalDate" ? (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key)
                          ? new Date(get(pariveshData, key)).toLocaleDateString(
                              "en-GB"
                            )
                          : "-"}
                      </div>
                    </div>
                  ) : key === "edsQueryHistoryUrl" ? (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key) ? (
                          <a href={get(pariveshData, key)} target="_blank">
                            {get(pariveshData, key)}
                          </a>
                        ) : (
                          "-"
                        )}
                      </div>
                    </div>
                  ) : key === "districtWiseArea" ? (
                    get(pariveshData, key) ? (
                      <div className="parivesh-detail-unit" key={key}>
                        <span>{label}:</span>
                        <div>
                          {get(pariveshData, key)
                            ? get(pariveshData, key)
                            : "-"}
                        </div>
                      </div>
                    ) : null
                  ) : (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key) ? get(pariveshData, key) : "-"}
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : issueSubCategoryId === 4 ? (
              //for WLC
              <div className="parivesh-detail-unit-wrapper">
                <div className="parivesh-proposal-no">
                  <span>Proposal Number:</span>
                  <div>{get(pariveshData, "proposalNo")}</div>
                </div>
                <hr />
                {PARIVESH_MAPPING_WLC.map(({ key, label }) =>
                  key === "dateOfSubmission" || key === "finalApprovalDate" ? (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key)
                          ? new Date(get(pariveshData, key)).toLocaleDateString(
                              "en-GB"
                            )
                          : "-"}
                      </div>
                    </div>
                  ) : key === "districtWiseArea" ? (
                    get(pariveshData, key) ? (
                      <div className="parivesh-detail-unit" key={key}>
                        <span>{label}:</span>
                        <div>
                          {get(pariveshData, key)
                            ? get(pariveshData, key)
                            : "-"}
                        </div>
                      </div>
                    ) : null
                  ) : (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key) ? get(pariveshData, key) : "-"}
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : issueSubCategoryId === 2 || issueSubCategoryId === 5 ? (
              //for EC & CRZ
              <div className="parivesh-detail-unit-wrapper">
                <div className="parivesh-proposal-no">
                  <span>Proposal Number:</span>
                  <div>{get(pariveshData, "proposalNo")}</div>
                </div>
                <hr />
                {PARIVESH_MAPPING_EC_CRZ.map(({ key, label }) =>
                  key === "dateOfSubmission" || key === "finalApprovalDate" ? (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key)
                          ? new Date(get(pariveshData, key)).toLocaleDateString(
                              "en-GB"
                            )
                          : "-"}
                      </div>
                    </div>
                  ) : key === "districtWiseArea" ? (
                    get(pariveshData, key) ? (
                      <div className="parivesh-detail-unit" key={key}>
                        <span>{label}:</span>
                        <div>
                          {get(pariveshData, key)
                            ? get(pariveshData, key)
                            : "-"}
                        </div>
                      </div>
                    ) : null
                  ) : (
                    <div className="parivesh-detail-unit" key={key}>
                      <span>{label}:</span>
                      <div>
                        {get(pariveshData, key) ? get(pariveshData, key) : "-"}
                      </div>
                    </div>
                  )
                )}
              </div>
            ) : null}
          </Modal.Body>
          {/* <Modal.Footer className="sticky-footer">

                      </Modal.Footer> */}
        </Modal>
      </React.Fragment>
    );
  }
}

export default PariveshData;
